import { put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import * as DesktopAppUtils from '../../../lib/DesktopAppUtils';
import { getCurrentListenerFromState } from '../../../lib/ListenerUtils';
import * as CoreRouteUtils from '../../../lib/RouteUtils';
import { getShareDeepLinkData } from '../../../lib/RouteUtils/CoreRouteUtils';
import * as UrlUtils from '../../../lib/utils/url';

export function* generateDeepLink({ payload }) {
  const { sourcePath, pandoraId, sourceType, sourceLocation } = payload;
  const deepLinkSourcePath = sourcePath
    ? sourcePath
    : yield select(DesktopAppUtils.getSourcePath, pandoraId, sourceType);
  const listener = yield select(getCurrentListenerFromState);
  const listenerId = listener ? listener.get('listenerId') : null;

  const applicationPort = UrlUtils.getUrlPort();
  const applicationHost = UrlUtils.getUrlHostName();
  let applicationURL = `https://${applicationHost}`;
  applicationURL += applicationPort !== '' ? `:${applicationPort}` : '';

  const desktopURL = listenerId
    ? `${applicationURL}${CoreRouteUtils.getDesktopLandingPath()}?part=ug-desktop&corr=${listenerId}`
    : '';

  const shareDeepLinkData = yield select(getShareDeepLinkData, {
    shareURL: desktopURL,
    sourceType,
    sourcePath: deepLinkSourcePath,
    sourceLocation,
  });

  yield put(
    Actions.DesktopApp.generateAndGotoBranchLink({
      deepLinkData: {
        ...shareDeepLinkData,
        $deeplink_path: `open?uri=${deepLinkSourcePath}`,
        $always_deeplink: true,
      },
      deepLinkSourcePath,
    }),
  );
}
